import React from "react";
import CustomTextField from "../CustomTextField/CustomTextField";

const amountInputSx = {
  "& input[type=number]": { MozAppearance: "textfield" },
  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
};

const AmountRangeFilter = ({ min, max, onMinChange, onMaxChange, onClearMin, onClearMax, t }) => (
  <div className="flex gap-1">
    <CustomTextField type="number" sx={amountInputSx} placeholder={t("min", "Min")} value={min} onChange={onMinChange} clearFilter={onClearMin} />
    <CustomTextField type="number" sx={amountInputSx} placeholder={t("max", "Max")} value={max} onChange={onMaxChange} clearFilter={onClearMax} />
  </div>
);

export default AmountRangeFilter;
